import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ListChecks } from "lucide-react";
import { http } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useRealtimeTick } from "@/lib/realtime";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function useOpeningToday() {
  const [t, setT] = useState(null);
  const tick = useRealtimeTick((m) => m.path.startsWith("/api/opening"));
  const load = () => http.get("/opening/today").then((r) => setT(r.data)).catch(() => {});
  useEffect(() => { load(); }, [tick]); // eslint-disable-line
  return [t, load];
}

export function OpeningPrompt() {
  const { user } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [t] = useOpeningToday();
  const [alerts, setAlerts] = useState(0);
  const aTick = useRealtimeTick((m) => ["/api/sales", "/api/notifications", "/api/day-end", "/api/opening"].some((p) => m.path.startsWith(p)));
  useEffect(() => { http.get("/notifications/alerts").then((r) => setAlerts(r.data.length)).catch(() => {}); }, [aTick, loc.pathname]);
  const key = `opening_later_${t?.date}`;
  const [later, setLater] = useState(false);
  useEffect(() => { setLater(!!sessionStorage.getItem(key)); }, [key]);
  if (!user || !t?.applicable || !t.assigned || t.done || later || alerts > 0 || loc.pathname === "/opening") return null;
  const close = () => { sessionStorage.setItem(key, "1"); setLater(true); };
  return (
    <Dialog open onOpenChange={(v) => !v && close()}>
      <DialogContent overlayClassName="z-[110]" className="z-[110] bg-slate-900 border-2 border-blue-500/50 max-w-sm text-center" data-testid="opening-prompt">
        <DialogHeader>
          <div className="mx-auto h-16 w-16 rounded-2xl bg-blue-500/15 border border-blue-500/40 flex items-center justify-center mb-2 text-blue-400"><ListChecks size={30} /></div>
          <DialogTitle className="text-center font-display text-2xl">Mağaza Açılış Listesi</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-400">{t.branch_name} için bugünün açılış listesi henüz doldurulmadı{t.open_time ? ` (açılış ${t.open_time})` : ""}.</p>
        <Button onClick={() => { close(); nav("/opening"); }} className="w-full py-5 bg-blue-600 hover:bg-blue-500" data-testid="opening-prompt-start">Şimdi Doldur</Button>
        <button onClick={close} className="text-xs text-slate-500 hover:text-slate-300" data-testid="opening-prompt-later">Sonra</button>
      </DialogContent>
    </Dialog>
  );
}
